import { Autocomplete, Box, CircularProgress, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  HandlersProgramResponse,
  useLazyGetApiProgramsQuery,
} from '../../app/athenaApiGen';

type TProgramFilterProps = {
  handleChange: (id?: string | null) => void;
  programId: string;
  required?: boolean;
};

const ProgramFilter = (props: TProgramFilterProps) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<HandlersProgramResponse[]>([]);
  const [queryPrograms, { isFetching: isLoading }] =
    useLazyGetApiProgramsQuery();

  const handleOpen = async () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    (async () => {
      try {
        const programs = await queryPrograms().unwrap();
        setOptions(programs);
        //default to first program
        props.handleChange(programs[0] ? programs[0]?.programId : null);
      } catch (err) {
        console.log(err);
      }
    })();
  }, [queryPrograms]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      <Autocomplete
        open={open}
        onOpen={handleOpen}
        onClose={handleClose}
        isOptionEqualToValue={(option, value) => option.title === value.title}
        getOptionLabel={(option) => option.title ?? ''}
        options={options}
        loading={isLoading}
        value={
          options.find((opt) => opt.programId === props.programId) ||
          options[0] ||
          null
        }
        onChange={(_, newValue) => {
          props.handleChange(newValue ? newValue?.programId : null);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Program"
            required={props.required}
            size="small"
            slotProps={{
              input: {
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {isLoading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              },
            }}
          />
        )}
      />
    </Box>
  );
};

export default ProgramFilter;
